import React from 'react';

import '../css/project.scss';

class PrjInfoCmp extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return (
            <React.Fragment>
                <ul className="prinfo">
                    <li>
                        <p className="cate">Mission</p>
                        <p className="cont">
                            {this.props.mission}
                        </p>
                    </li>
                    <li>
                        <p className="cate">Partner</p>
                        <p className="cont">
                            {this.props.partner}
                        </p>
                    </li>
                    <li>
                        <p className="cate">launch</p>
                        <p className="cont">
                            {this.props.launch}
                        </p>
                    </li>
                    <li>
                        <p className="cate">Link</p>
                        <p className="cont">
                            {this.props.url}
                        </p>
                    </li>
                </ul>
            </React.Fragment>
        )
    }
}

export default PrjInfoCmp;